import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {  Pager } from 'src/consts/common.model';
import { HttpCall } from 'src/app/services/httpcall.service';
import { UnsubscribeOnDestroyAdapter } from 'src/app/shared/UnsubscribeOnDestroyAdapter';
import { httpVersion, httpRoutes } from 'src/consts/http-routes';
import { PortalTicketModel, StatusWiseDataTableRequest } from './common-components.model';

@Injectable({
    providedIn: 'root'
})
export class CommonComponentsService extends UnsubscribeOnDestroyAdapter {
    private readonly API_URL = 'assets/data/advanceTable.json';
    
    constructor (private httpCall: HttpCall) {
        super();
    }
    // Ticket system
    ticketisTblLoading = true;
    ticketdataChange: BehaviorSubject<PortalTicketModel[]> = new BehaviorSubject<PortalTicketModel[]>([]);
    ticketPager: BehaviorSubject<Pager> = new BehaviorSubject<Pager>({ first: 0, last: 0, total: 0 });

    get TicketData(): PortalTicketModel[] {
        return this.ticketdataChange.value;
    }

    get TicketPagerData(): Pager {
        return this.ticketPager.value;
    }

    // Data table API for Users contact
    async getTicketTable(requestObject: StatusWiseDataTableRequest): Promise<void> {
        const data = await this.httpCall.httpPostCall(httpVersion.PORTAL_V1 + httpRoutes.PORTAL_TICKET_GET_TABLE, requestObject).toPromise();
        this.ticketdataChange.next(data.data);
        this.ticketPager.next(data.pager);
        this.ticketisTblLoading = false;
    }

    
}
